import { KeyTypeFigurant } from 'models';
import capitalize from 'commons/utils/capitalize';

import { KeySrcTypes, ReturnValueFunc, SRC_TYPES } from '../../@types';
import { PropsBuildAction } from '../../utils';
import { Typography } from 'components/elements';
import * as S from '../../styles';
import * as CONSTANTS from '../../constants';

type Props = {
  selected: boolean;
  src?: KeySrcTypes;
  submitBySrc: Record<KeySrcTypes, PropsBuildAction>;
  name: string;
  extraUnavailable: boolean;
  figurantUnavailable: boolean;
  colorUnavailableFigurant: string;
  colorSelectedFigurant: string;
  type: KeyTypeFigurant;
  missingInformation: boolean;
  isTextAvailable: boolean;
  renderInfo: ReturnValueFunc[];
};

export const MainContent = ({
  selected,
  src,
  submitBySrc,
  name,
  colorUnavailableFigurant,
  extraUnavailable,
  figurantUnavailable,
  type,
  missingInformation,
  isTextAvailable,
  colorSelectedFigurant,
  renderInfo,
}: Props) => {
  const shouldRenderInfoFigurant = isTextAvailable && !selected && !missingInformation;
  const figurantIsFiscalAndFigurantThisIsUnavailable =
    src === SRC_TYPES.CLIMBED && figurantUnavailable && type === CONSTANTS?.typeFiscal;

  return (
    <>
      {selected && src !== SRC_TYPES.SEARCH && (
        <S.Description fontSize={submitBySrc[src as SRC_TYPES]?.fontSize}>
          {submitBySrc[src as SRC_TYPES]?.getDescription(name)}
        </S.Description>
      )}
      {extraUnavailable && <S.Description color={colorUnavailableFigurant}>Figurante indisponível</S.Description>}
      {figurantIsFiscalAndFigurantThisIsUnavailable && (
        <S.Description color={colorUnavailableFigurant}>Fiscal indisponível</S.Description>
      )}
      {missingInformation && <S.Description color={colorUnavailableFigurant}>Atualização necessária</S.Description>}
      {shouldRenderInfoFigurant &&
        renderInfo.map(({ label, value }, index: number) => (
          <Typography key={`${label}-${index}`} fontSize="14px" color={colorSelectedFigurant}>
            {label} {capitalize(value || '')}
          </Typography>
        ))}
    </>
  );
};
